import {
  KitFeedback,
  KitFeedbackRating,
} from 'components/Kit/EmailSuggestions/components/KitFeedback';
import { submitQQAgentFeedback } from 'lib/api/agents/submitQQAgentFeedback';
import { QQAgentFeedbackRating } from 'types/agents/QuickQuoteAgent';

type AgentFeedbackProps = {
  invocationId: number;
};

// Thumbs up/down on a written-rules agent run, with an optional short note.
export function AgentFeedback({ invocationId }: AgentFeedbackProps) {
  return (
    <KitFeedback
      upLabel='Kit got this right'
      downLabel='Kit got this wrong'
      upPlaceholder='Anything to add? (optional)'
      downPlaceholder='What should Kit have done? (optional)'
      buttonNamePosthog='qq_agent_written_rules_feedback'
      successToast='Thanks. This helps Kit quote the way you would.'
      testId='agent-feedback'
      onSubmit={(rating, note) =>
        submitQQAgentFeedback({
          invocationId,
          rating: toAgentRating(rating),
          note,
        })
      }
    />
  );
}

function toAgentRating(rating: KitFeedbackRating): QQAgentFeedbackRating {
  return rating === KitFeedbackRating.Up
    ? QQAgentFeedbackRating.Up
    : QQAgentFeedbackRating.Down;
}
